import Guid from "_shared/guids/guid";
import Forum from "messaging/forums/forum";
import { NetworkConnectionForumJSON } from "users/networking/connections/_schemas/network-connection-forum-schema";

/**
 * The chat between two connected users, as the messaging domain's `Forum`. The network API sends
 * only the subscribers' user ids, so each subscriber's legal entity is left empty: a chat between
 * contacts belongs to neither firm.
 */
export function getNetworkConnectionChatForum(forumData?: NetworkConnectionForumJSON | null): Forum | null {
  if (!forumData) return null;

  return Forum.fromJSON({
    id: forumData.id,
    name: forumData.name,
    createdDate: forumData.createdDate,
    entityClass: forumData.entityClass,
    entityId: forumData.entityId,
    context: forumData.context,
    subscribers:
      forumData.subscriberIds?.map((forumUserId: string) => ({
        userId: forumUserId,
        legalEntityId: Guid.EMPTY.value,
      })) ?? [],
  });
}
